import React from 'react';
import {BtnSearchBtn} from "./style/ButtonStyle";
import {useEffect} from "react";



function BtnSearchDetail({isDetailOpen, setIsDetailOpen, detailButtonRef}) {

    //상세버튼 클릭시
    const handleBtnSearchDetailClick = () => {
        setIsDetailOpen(!isDetailOpen);
    }


    return (
        <BtnSearchBtn
            ref={detailButtonRef}
            className="search-detail-btn"
            onClick={handleBtnSearchDetailClick}
        >
            검색조건
        </BtnSearchBtn>
    );
}
export default BtnSearchDetail;